"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduledTaskOwnerEntityType = exports.ScheduledTaskType = exports.DAILY_DEV_STATS_GENERATOR_CRON_TIMER = exports.DAY_OF_WEEK_DAY_OF_MONTH_MONTH_FORMAT = void 0;
exports.DAY_OF_WEEK_DAY_OF_MONTH_MONTH_FORMAT = "ddd, Do MMM";
exports.DAILY_DEV_STATS_GENERATOR_CRON_TIMER = "0 0 * * *";
var ScheduledTaskType;
(function (ScheduledTaskType) {
    ScheduledTaskType["SHORT_SLACK_DIGEST_PUSH"] = "SHORT_SLACK_DIGEST_PUSH";
    ScheduledTaskType["LONG_SLACK_DIGEST_PUSH"] = "LONG_SLACK_DIGEST_PUSH";
    ScheduledTaskType["SLACK_DEVELOPER_SUMMARY_PUSH"] = "SLACK_DEVELOPER_SUMMARY_PUSH";
    ScheduledTaskType["GO_RETRO_SPRINT_REVIEW_NOTIFIER"] = "GO_RETRO_SPRINT_REVIEW_NOTIFIER";
    ScheduledTaskType["DAILY_DEV_STATS_GENERATOR"] = "DAILY_DEV_STATS_GENERATOR";
})(ScheduledTaskType = exports.ScheduledTaskType || (exports.ScheduledTaskType = {}));
var ScheduledTaskOwnerEntityType;
(function (ScheduledTaskOwnerEntityType) {
    ScheduledTaskOwnerEntityType["DataContributor"] = "DataContributor";
    ScheduledTaskOwnerEntityType["Integration"] = "Integration";
})(ScheduledTaskOwnerEntityType = exports.ScheduledTaskOwnerEntityType || (exports.ScheduledTaskOwnerEntityType = {}));
//# sourceMappingURL=scheduled-tasks.js.map